import { render } from "./content.vue?vue&type=template&id=c890a5a2&scoped=true&ts=true"
import script from "./content.vue?vue&type=script&lang=ts"
export * from "./content.vue?vue&type=script&lang=ts"

import "./content.vue?vue&type=style&index=0&id=c890a5a2&lang=less"
import "./content.vue?vue&type=style&index=1&id=c890a5a2&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c890a5a2"]])

export default __exports__